var _slicedToArray = require("/Users/karl/github/static-www/node_modules/@babel/runtime/helpers/slicedToArray");

var _require = require('react'),
    useState = _require.useState,
    useLayoutEffect = _require.useLayoutEffect,
    useEffect = _require.useEffect;

var _require2 = require('../get-matches'),
    getMatches = _require2.getMatches;

var isBrowser = typeof window !== 'undefined';
var useEnhancedEffect = isBrowser ? useLayoutEffect : useEffect;

var useMediaQuery = function useMediaQuery() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var _useState = useState(getMatches(query)),
      _useState2 = _slicedToArray(_useState, 2),
      isMatch = _useState2[0],
      setIsMatch = _useState2[1];

  useEnhancedEffect(function () {
    var mounted = true;
    var mediaQueryList = window.matchMedia(query.replace(/^@media\s*/, ''));

    var handleChange = function handleChange() {
      if (!mounted) return;
      setIsMatch(mediaQueryList.matches);
    }; // Safari < 14 can't use addEventListener on a MediaQueryList
    // https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList#Browser_compatibility


    if (mediaQueryList.addListener) {
      mediaQueryList.addListener(handleChange);
    } else {
      mediaQueryList.addEventListener('change', handleChange);
    }

    setIsMatch(mediaQueryList.matches);
    return function () {
      mounted = false;

      if (mediaQueryList.addListener) {
        mediaQueryList.removeListener(handleChange);
      } else {
        mediaQueryList.removeEventListener('change', handleChange);
      }
    };
  }, [query]);
  return isMatch;
};

exports.useMediaQuery = useMediaQuery;